<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4ZJiR9/tc-custom/9781466846685.jpg?1733082678957" alt="This image is the cover for the book Breaking Point"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breaking Point
      </h1>
      <p class="bookDescription body article font2">
        <p> David Hagberg brings us another Kirk McGarvey adventure, in which the CIA director becomes entangled in the rising tensions between China and Taiwan. When a revolutionary leader is rescued from a Chinese prison, the Chinese government pushes the United States to the brink of war, and McGarvey has to make a choice with the fate of the world hanging in the balance. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Hagberg
      </h2>
      
      <p class="authorDescription body article"><B>David Hagberg </B>is a former Air Force cryptographer who has traveled extensively in Europe, the Arctic, and the Caribbean and has spoken at CIA functions. He has published more than twenty novels of suspense, including the bestselling <I>High Flight, Assassin, </I>and <I>Joshua's Hammer.</I> He makes his home in Vero Beach, Florida.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e5cc0a1